var React = require('react');

function GraphLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.067 4.004a1 1 0 01.92.842l5.162 32.688 4.873-22.742a1 1 0 011.907-.161l3.748 9.371H47a1 1 0 110 2H35a1 1 0 01-.928-.629L31.29 18.42l-5.312 24.791a1 1 0 01-1.966-.053L18.697 9.493l-4.74 15.796a1 1 0 01-.957.713H1a1 1 0 110-2h11.256l5.786-19.287a1 1 0 011.025-.71z"}));
}

GraphLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = GraphLight;

GraphLight.default = GraphLight;
